import { TRACK_HEIGHT, TRACK_SEPARATOR_STROKE_WIDTH } from '../constants.js';

export const getAnnotationsTracksHeight = (tracksCount: number): number => {
  if (tracksCount > 0) {
    return tracksCount * TRACK_HEIGHT + TRACK_SEPARATOR_STROKE_WIDTH;
  }

  return 0;
};
